import { Ion } from "@/components/Ion";

export const flashTo = (testId) => {
  const el = document.querySelector(`[data-testid="${testId}"]`);
  if (!el) return;
  el.scrollIntoView({ behavior: "smooth", block: "center" });
  el.classList.remove("qb-flash");
  void el.offsetWidth;
  el.classList.add("qb-flash");
  setTimeout(() => el.classList.remove("qb-flash"), 2600);
  const input = el.matches("input,textarea") ? el : [...el.querySelectorAll("input,textarea")].find((i) => !i.value);
  setTimeout(() => input?.focus({ preventScroll: true }), 450);
};

export const MissingList = ({ items, testId = "missing-steps", title = "Before you can calculate" }) => {
  if (!items.length) {
    return <p className="mb-3 flex items-center gap-1.5 px-1 text-[12px] font-bold text-[#4CCC06]" data-testid={`${testId}-ready`}><Ion name="checkmark-circle" size={15} color="#4CCC06" />Everything's filled in. Ready to calculate.</p>;
  }
  return (
    <div className="mb-3 rounded-[12px] border border-[#F59E0B] bg-[#F59E0B12] p-3" data-testid={testId} role="status">
      <p className="mb-2 flex items-center gap-1.5 text-[11px] font-extrabold tracking-[1px] text-[#F59E0B]"><Ion name="alert-circle" size={14} color="#F59E0B" />{title.toUpperCase()} ({items.length})</p>
      {items.map((m, i) => (
        <button key={`${m.target}-${i}`} onClick={() => flashTo(m.target)} className="flex w-full items-start gap-2 rounded-[8px] px-1.5 py-1.5 text-left text-[12px] leading-4 text-white transition-colors hover:bg-[#F59E0B1F]" data-testid={`${testId}-item-${i}`}>
          <span className="mt-[5px] h-1.5 w-1.5 shrink-0 rounded-full bg-[#F59E0B]" /><span className="flex-1">{m.msg}</span><span className="shrink-0 text-[10px] font-extrabold text-[#F59E0B]">SHOW ME</span>
        </button>
      ))}
    </div>
  );
};
